import { useNavigate } from 'react-router-dom'
import Button from '~/components/Button'
import SuccessSvg from '~/components/illustrations/Succes'

export const SuccessStep = ({isLoading = false}: {isLoading?: boolean}) => {
  const navigate = useNavigate()

  return (
    <div className='flex flex-col items-center md:w-1/2 mx-auto w-full p-4'>
      <SuccessSvg />

      <p className='title text-center'>Succesvol ingesteld!</p>

      <p className='text-center'>Je kunt nu gebruik maken van de Mijn Polissen.</p>

      <Button
        className={'primary-btn w-full mt-8 mb-3'}
        type='button'
        onClick={() => navigate('/home')}
        isLoading={isLoading}
      >
      Doorgaan
      </Button>
    </div>
  )
}
